import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { createRoot, Root } from 'react-dom/client';
import * as React from 'react';

const BottomNavActions = require('@react/components/navigation/BottomNavActions').default;

export type BottomNavMode = 'taiao' | 'mapview' | 'maramataka';

/**
 * Angular host for the React/Chakra bottom-navigation buttons.
 *
 * Angular owns routing and the active view; React owns the button styling and
 * interaction.
 */
@Component({
  selector: 'app-bottom-nav-actions',
  template: '<div class="bottom-nav-actions-root"></div>',
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
      }

      .bottom-nav-actions-root {
        display: inline-flex;
        align-items: center;
      }
    `,
  ],
})
export class BottomNavActionsBridgeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() activeMode = 'taiao';
  @Input() rongoUrl = '';

  @Output() navigate = new EventEmitter<BottomNavMode>();

  private reactRoot: Root | null = null;

  constructor(private el: ElementRef<HTMLElement>, private ngZone: NgZone) {}

  ngOnInit(): void {
    const container = this.el.nativeElement.querySelector('.bottom-nav-actions-root');
    if (!container) return;

    this.reactRoot = createRoot(container);
    this.renderActions();
  }

  ngOnChanges(): void {
    this.renderActions();
  }

  ngOnDestroy(): void {
    this.reactRoot?.unmount();
    this.reactRoot = null;
  }

  private renderActions(): void {
    if (!this.reactRoot) return;

    this.reactRoot.render(
      React.createElement(BottomNavActions, {
        activeMode: this.activeMode,
        rongoUrl: this.rongoUrl,
        onNavigate: (mode: BottomNavMode) => this.ngZone.run(() => this.navigate.emit(mode)),
      })
    );
  }
}
